import React from 'react';
import { Button, Form, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Grades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesterOptions: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchMarkOptions = this.fetchMarkOptions.bind(this);
        this.fetchExamOptions = this.fetchExamOptions.bind(this);
        this.fetchStaffOptions = this.fetchStaffOptions.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.addGrade = this.addGrade.bind(this);
    }


    componentDidMount() {
        this.fetchMarkOptions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.ungradedCourseImplementations !== prevProps.ungradedCourseImplementations) {
            this.resetForm();
        }
    }

    fetchStaffOptions(examId) {
        axios.get(`/exams/staff/${examId}/`)
            .then(res => {
                this.setState({
                    staffOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.staff.employee.person.firstName + ' ' + el.staff.employee.person.lastName
                    }))
                });
            });
    }
    fetchExamOptions(courseImplementationId) {
        axios.get(`/exams/by-course-implementation/${courseImplementationId}/`)
            .then(res => {
                this.setState({
                    examOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: moment(el.date).format('D. M. YYYY.')
                        // + (' | ' + el.type.name) + (el.comment ? ' | ' + el.comment : '')
                    }))
                });
            });
    }

    fetchMarkOptions() {
        axios.get('/marks')
            .then(res => {
                this.setState({
                    markOptions: res.data.map(el => ({
                        key: el.id, value: el.id, text: el.displayName
                    }))
                });
            });
    }

    resetForm() {
        this.setState({

            mark: null,
            academicYear: null,
            semester: null,
            courseImplementation: null,
            exam: null,
            staff: null,

        });
    }

    addGrade() {
        if (!this.state.courseImplementation || !this.state.exam || !this.state.mark) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.courseImplementation) { this.setState({ courseImplementationErr: true }); } else { this.setState({ courseImplementationErr: false }); }
            if (!this.state.exam) { this.setState({ examErr: true }); } else { this.setState({ examErr: false }); }
            if (!this.state.mark) { this.setState({ markErr: true }); } else { this.setState({ markErr: false }); }
        } else {
            this.setState({ loader: true });
            let obj = {
                studentCourseImplementationId: this.props.ungradedCourseImplementations.find((e) => e.courseImplementationId === this.state.courseImplementation).studentCourseImplementationId,
                gradedActivityId: this.state.exam,
                markId: this.state.mark,
                staffGradedActivityId: this.state.staff
            };
            axios.post('/grade-student/', { ...obj }).then((res) => {
                toast('Uspješno ste ocijenili studenta!');
                this.setState({ loader: false });
                this.props.fetchUngradedCourseImplementations();
                this.resetForm();
            }).catch(() => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Studentu nije unešena ocjena.');
            });
        }
    }

    handleInputChange(event, { name, value }) {
        // if (name === 'student' && this.state.academicYear && this.state.semester) { this.fetchCourseImplementationOptions(value, this.state.academicYear, this.state.semester); }
        // if (name === 'academicYear') { this.fetchSemesterOptions(value); if (this.state.student && this.state.semester) { this.fetchCourseImplementationOptions(this.state.student, value, this.state.semester); } }
        // if (name === 'semester' && this.state.academicYear && this.state.student) { this.fetchCourseImplementationOptions(this.state.student, this.state.academicYear, value); }
        if (name === 'courseImplementation') { this.fetchExamOptions(value); }
        if (name === 'exam') { this.fetchStaffOptions(value); }


        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Loader active={this.state.loader} />
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.courseImplementationErr}>
                            <label>Nepoloženi predmet </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir predmeta"
                                value={this.state.courseImplementation}
                                onChange={this.handleInputChange}
                                name="courseImplementation"
                                // disabled={!this.state.student || !this.state.academicYear || !this.state.semester}
                                options={this.props.ungradedCourseImplementations}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.examErr}>
                            <label>Ispit </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir ispita"
                                value={this.state.exam}
                                onChange={this.handleInputChange}
                                name="exam"
                                disabled={!this.state.courseImplementation}
                                options={this.state.examOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field >
                            <label>Profesor </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir implementacije"
                                value={this.state.staff}
                                onChange={this.handleInputChange}
                                name="staff"
                                disabled={!this.state.exam}
                                options={this.state.staffOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.markErr}>
                            <label>Ocjena </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir ocjene"
                                value={this.state.mark}
                                onChange={this.handleInputChange}
                                name="mark"
                                options={this.state.markOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button
                        floated="right"
                        color="blue"
                        onClick={() => {
                            this.addGrade();
                        }}
                    >Ocijeni studenta </Button>
                    <br />
                    <br />
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Students/InputGrades/Grades.js